import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import { Editor } from '@tinymce/tinymce-react'; // TinyMCE editor
import {
  fetchTermsConditions,
  updateTermsConditions,
  clearMessages,
} from '../../../redux/slices/admin/privacyPolicyTermsSlice'; // Adjust your slice import path
import '../../../global.css';

const TermsAndConditions = () => {
  const dispatch = useDispatch();

  // Selectors from the Redux state
  const { termsConditions, loading, error, successMessage } = useSelector(
    (state) => state.policy
  );

  const [content, setContent] = useState(''); // To hold the editor content

  // Fetch Terms and Conditions on component mount
  useEffect(() => {
    dispatch(fetchTermsConditions());
  }, [dispatch]);

  // Populate the editor with the fetched Terms and Conditions content
  useEffect(() => {
    if (termsConditions) {
      setContent(termsConditions);
    }
  }, [termsConditions]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateTermsConditions(content));
  };

  const handleClearMessages = () => {
    dispatch(clearMessages());
  };

  return (
    <Layout>
      <main className="main">
        <header>
          <div className="main-head flex justify-between align-center pb-0">
            <h1 className="greet-user-text">Update Terms and Conditions</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </div>
        </header>
        <div className="main-content flex justify-between flex-col-rev-mob">
          <div style={{ width: '100%' }}>
            <div className="meals-container meals-added">
              <div className="card">
                {/* Bootstrap Alerts */}
                {successMessage && (
                  <div
                    className="alert alert-success alert-dismissible fade show"
                    role="alert"
                  >
                    {successMessage}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClearMessages}
                    ></button>
                  </div>
                )}
                {error && (
                  <div
                    className="alert alert-danger alert-dismissible fade show"
                    role="alert"
                  >
                    {error}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleClearMessages}
                    ></button>
                  </div>
                )}
                <form
                  onSubmit={handleSubmit}
                  style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
                >
                  <Editor
                    apiKey="3ekhofkbsu98q13bzu60y7zbqcr9yd5fhnmhz706zfyv2ges" // Replace with your TinyMCE API key
                    value={content}
                    onEditorChange={(newContent) => setContent(newContent)}
                    init={{
                      height: 400,
                      menubar: true,
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                      content_style:
                        'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    }}
                  />
                  <div className="form-buttons">
                    <button type="submit" className="btn btn-create w-100">
                      Update
                    </button>
                  </div>
                </form>
              </div>
              {loading && <p>Loading...</p>}
            </div>
          </div>
        </div>
      </main>
      <style jsx>{`
        .submit-btn {
          background-color: #007bff;
          color: #fff;
          border: none;
          padding: 10px 20px;
          font-size: 16px;
          cursor: pointer;
          border-radius: 5px;
          transition: background-color 0.3s ease;
        }
        .submit-btn:hover {
          background-color: #0056b3;
        }
      `}</style>
    </Layout>
  );
};

export default TermsAndConditions;
